export const defaultRender = (text: string) => {
  return text || '-'
}
export const defaultRender = (text: string) => {
  return text || '-'
}
